import * as core from '../../../../../../../core'

import { query } from './type-bar-chart.query'

export const RESOURCE = {
  payload: {
    alias: 'type.bar.chart',
    description: 'Bar chart of change impacts by type',
    name: 'Type Bar Chart',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
